import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { AzureBlobStorageService } from '../baseServices/azure-blob-storage.service';
import { BlobType } from '../enums/blob-storage/blob-type.enum';
import { dataUrlToBlob } from '../utils/converters/to-blob.util';

@Injectable({
  providedIn: 'root'
})
export class FormDocumentVideoUploadService extends DataService {

  constructor(private azureBlobStorageService: AzureBlobStorageService) {
    super();
  }

  async uploadVideo(fileName: string, dataUrl: string): Promise<string> {
    const blob = dataUrlToBlob(dataUrl);

    // Creating a File directly using File constructor does not set file name correctly on iOS
    const namedBlob = blob as Blob & { name?: string };
    namedBlob.name = fileName;
    const file = namedBlob as File;

    const token = await this.azureBlobStorageService.uploadInChunks(file, BlobType.VIDEO);
    return token;
  }
}
